<div [chart]="chart" class="h-[300px]"></div>
